export const ACCOUNT_TYPES = {
    ASSET: 'asset',
    LIABILITY: 'liability',
    EQUITY: 'equity',
    REVENUE: 'revenue',
    EXPENSE: 'expense'
};

export const ACCOUNT_TYPE_LABELS = {
    [ACCOUNT_TYPES.ASSET]: '資産',
    [ACCOUNT_TYPES.LIABILITY]: '負債',
    [ACCOUNT_TYPES.EQUITY]: '純資産',
    [ACCOUNT_TYPES.REVENUE]: '収益',
    [ACCOUNT_TYPES.EXPENSE]: '費用'
};

export const ACCOUNT_TYPE_BADGES = {
    [ACCOUNT_TYPES.ASSET]: 'badge-asset',
    [ACCOUNT_TYPES.LIABILITY]: 'badge-liability',
    [ACCOUNT_TYPES.EQUITY]: 'badge-equity',
    [ACCOUNT_TYPES.REVENUE]: 'badge-revenue',
    [ACCOUNT_TYPES.EXPENSE]: 'badge-expense'
};

// 日本語→内部値マッピング
export const TYPE_MAP = {
    '資産': ACCOUNT_TYPES.ASSET,
    '負債': ACCOUNT_TYPES.LIABILITY,
    '純資産': ACCOUNT_TYPES.EQUITY,
    '収益': ACCOUNT_TYPES.REVENUE,
    '費用': ACCOUNT_TYPES.EXPENSE
};

export const TYPE_MAP_REVERSE = {
    [ACCOUNT_TYPES.ASSET]: '資産',
    [ACCOUNT_TYPES.LIABILITY]: '負債',
    [ACCOUNT_TYPES.EQUITY]: '純資産',
    [ACCOUNT_TYPES.REVENUE]: '収益',
    [ACCOUNT_TYPES.EXPENSE]: '費用'
};

export const HOME_MAP = { '借方': 'debit', '貸方': 'credit' };
export const HOME_MAP_REVERSE = { 'debit': '借方', 'credit': '貸方' };
export const STATEMENT_MAP = { '貸借対照表': 'BS', '損益計算書': 'PL', '正味財産増減計算書': 'PL' };
export const STATEMENT_MAP_REVERSE = { 'BS': '貸借対照表', 'PL': '正味財産増減計算書' };

// 勘定科目コードからtypeを推定（日本の標準的な勘定科目コード体系）
export const inferAccountType = (account) => {
    // 既にtypeがあればそれを使用
    if (account.type) return account.type;

    const code = String(account.code || '');
    const firstDigit = code.charAt(0);

    // statementがPLなら収益か費用
    if (account.statement === 'PL') {
        // 4で始まるか、売上・収入などを含む場合は収益
        if (firstDigit === '4' || /売上|収入|受取|雑収|経常収益|事業収益/.test(account.name)) {
            return ACCOUNT_TYPES.REVENUE;
        }
        return ACCOUNT_TYPES.EXPENSE;
    }

    // statementがBSなら資産・負債・純資産
    // コードの先頭桁で判定
    if (firstDigit === '1') return ACCOUNT_TYPES.ASSET;
    if (firstDigit === '2') return ACCOUNT_TYPES.LIABILITY;
    if (firstDigit === '3') return ACCOUNT_TYPES.EQUITY;

    // 名前から推定
    if (/現金|預金|売掛|未収|棚卸|前払|貸付|備品|車両|建物|土地|繰延/.test(account.name)) {
        return ACCOUNT_TYPES.ASSET;
    }
    if (/買掛|未払|前受|借入|預り/.test(account.name)) {
        return ACCOUNT_TYPES.LIABILITY;
    }
    if (/正味財産|資本|基金|利益剰余金|元入金/.test(account.name)) {
        return ACCOUNT_TYPES.EQUITY;
    }

    // デフォルト: BSなら資産、PLなら費用
    return account.statement === 'BS' ? ACCOUNT_TYPES.ASSET : ACCOUNT_TYPES.EXPENSE;
};
